(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$translate', '$localStorage'];

    function JhiLanguageService($q, $translate, $localStorage) {
        var service = {
            setLanguages: setLanguages,
            getLanguages: getLanguages,
            getAll: getAll,
            getCurrent: getCurrent
        };
        init();
        return service;

        function init() {
            if ($localStorage.languages == undefined) {
                $localStorage.languages = ['de', 'en'];
            }
        }

        function getAll() {
            var deferred = $q.defer();
            deferred.resolve($localStorage.languages);
            return deferred.promise;
        }

        function getCurrent() {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }

        function setLanguages(langs) {
            if (!langs) {
                return;
            }

            var splitted = langs.split(',');
            var languages = [];
            angular.forEach(splitted, function(value){
                languages.push(value);
            });

            $localStorage.languages = languages;

        }

        function getLanguages() {
            return $localStorage.languages;
        }
    }
})();
